var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import './ChatsControlPage.scss';
import { useDebounce } from '@/hooks/redux';
import InputSearch from '@/components/InputSearch/InputSearch';
import { useDeleteChatMutation, useGetChatsByRestIdWithPaginationQuery } from '@/services/chatsApi';
import Loader from '@/components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { useGetRestaurantsQuery } from '@/services/restaurantsApi';
import ChatItem from './ChatItem/chatItem';
var ChatsControlPage = function (_a) {
    var restId = _a.restId;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var _c = useState(null), restaurant = _c[0], setRestaurant = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(false), isArchived = _e[0], setIsArchived = _e[1];
    var limit = 10;
    var navigate = useNavigate();
    var _f = useGetRestaurantsQuery({}), restaurantsData = _f.data, isRestaurantsLoading = _f.isLoading;
    var _g = useGetChatsByRestIdWithPaginationQuery({ search: search, limit: limit, restaurantId: restId, isArchived: isArchived, page: page }, { skip: !restaurant }), chatsData = _g.data, refetchChats = _g.refetch, isChatsLoading = _g.isLoading, isFetching = _g.isFetching;
    var deleteChat = useDeleteChatMutation()[0];
    var handleToggle = function () {
        setIsArchived(!isArchived);
    };
    var handleDeleteChat = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deleteChat({ id: Number(id) }).unwrap()];
                    case 1:
                        _a.sent();
                        console.log("Chat with id ".concat(id, " deleted successfully"));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to delete the chat:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    console.log(chatsData);
    useEffect(function () {
        if (restaurantsData && restaurantsData.length > 0) {
            var firstRestaurant = restaurantsData[0];
            setRestaurant(firstRestaurant);
        }
    }, [restaurantsData]);
    useEffect(function () {
        if (restaurant) {
            refetchChats();
        }
    }, [restaurant, refetchChats]);
    var debouncedSetSearchText = useDebounce(function (text) {
        setSearch(text);
        setPage(1);
    }, 300);
    var handleNavigation = function (item) {
        navigate("/chats/".concat(item.chat.id, "?restaurantId=").concat(restaurant === null || restaurant === void 0 ? void 0 : restaurant.id));
    };
    var handlePreviousPage = function () {
        if (page > 1) {
            setPage(function (prevPage) { return prevPage - 1; });
        }
    };
    var handleNextPage = function () {
        if (page * limit < ((chatsData === null || chatsData === void 0 ? void 0 : chatsData.total) || 0)) {
            setPage(function (prevPage) { return prevPage + 1; });
        }
    };
    return (_jsx("div", __assign({ className: 'ChatsUpdateRestPage' }, { children: _jsxs("div", __assign({ style: { padding: '0 40px 40px 40px' } }, { children: [_jsx(InputSearch, { setSearch: debouncedSetSearchText }), _jsx("div", { style: { height: '24px' } }), _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', marginBottom: '16px' } }, { children: [_jsx("span", __assign({ style: { fontFamily: "Montserrat Regular" } }, { children: "\u0410\u0440\u0445\u0438\u0432\u043D\u044B\u0435 \u0447\u0430\u0442\u044B" })), _jsxs("label", __assign({ style: { marginLeft: '8px', position: 'relative', display: 'inline-block', width: '60px', height: '34px' } }, { children: [_jsx("input", { type: "checkbox", checked: isArchived, onChange: handleToggle, style: { opacity: 0, width: 0, height: 0 } }), _jsx("span", __assign({ style: {
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: isArchived ? '#E621E3' : '#ccc',
                                        transition: '.4s',
                                        borderRadius: '34px'
                                    } }, { children: _jsx("span", { style: {
                                            position: 'absolute',
                                            height: '26px',
                                            width: '26px',
                                            left: '4px',
                                            bottom: '4px',
                                            backgroundColor: 'white',
                                            transition: '.4s',
                                            borderRadius: '50%',
                                            transform: isArchived ? 'translateX(26px)' : 'translateX(0)'
                                        } }) }))] }))] })), !isChatsLoading || !isFetching ? (_jsx("div", { children: chatsData && chatsData.data && chatsData.data.length ? (chatsData.data // Фильтрация по restId
                        .map(function (chat, index) { return (_jsx(ChatItem, { handleDelete: function () { handleDeleteChat(chat.chat.id); }, chatData: chat, isFirst: index === 0, onClick: function () { return handleNavigation(chat); }, isLast: index === chatsData.data.length - 1 }, index)); })) : (_jsxs(TabletsList, { children: [_jsx(EmptyList, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 400, fontSize: '16px' } }, { children: "\u0417\u0434\u0435\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u0447\u0430\u0442\u043E\u0432" }))] })) })) : (_jsx(LoaderContainer, { children: _jsx(Loader, {}) })), _jsxs(PaginationContainer, { children: [_jsx(ChangePageButton, __assign({ onClick: handlePreviousPage, disabled: page === 1 }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) })), _jsxs("span", { children: ["\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ", page] }), _jsx(ChangePageButton, __assign({ onClick: handleNextPage, disabled: page * limit >= ((chatsData === null || chatsData === void 0 ? void 0 : chatsData.total) || 0) }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) }))] })] })) })));
};
var PageHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"], ["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"])));
var LoaderContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"])));
var PaginationContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"])));
var ChangePageButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"])));
var TabletsList = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
var EmptyList = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"])));
export default ChatsControlPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
